import axios from 'axios'
import {
  getUserToken
} from './functions.js'
import {getServerApi} from './config/deployment'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

let envUri = getServerApi()
let requestsUri = envUri+'/api/requests'


export const getDisabledBookingDates = (listingId) =>{
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var data= {
          token: token,
          listingId: listingId
        }
        return makeRequestsPostRequest(availableDatesUri, data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
  })
}

export const getRequestIds = (prospectUid, ownerUid, status) =>{
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var data= {
          token: token,
          prospectUid:prospectUid,
          ownerUid:ownerUid,
          status:status
        }
        makeRequestsPostRequest(requestsUri+"/ids", data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
  })
}


export const getRequest = (requestId) =>{
  return new Promise((resolve, reject) => {
    getUserToken()
      .then(token => {
        var data= {
          token: token,
          requestId: requestId
        }
        makeRequestsPostRequest(requestsUri, data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
  })
}

let makeRequestsPostRequest =(uri, data)=>{
  return new Promise((resolve, reject) => {
    axios.post(uri, data)
      .then(response => {
        if (response.status == 200 && response.data.body) resolve(response.data.body)
        else reject("cannot get")
      })
      .catch(err => { reject(err) })
  })

}

export const updateRequest = (request) =>{
  return getUserToken()
    .then(tokenResponse => {
      var user = getCurrentFirebaseUser()
      var uid = ''
      if (user) {
        uid = user.uid
        var serverRequest
        //### UPDATE
        var requestId = request.id
        if(requestId && requestId != ""){
          serverRequest = {
            'id': requestId,
            'status': request.status,
            'periodStart': request.periodStart,
            "periodEnd": request.periodEnd,
            "token":tokenResponse
          }
        }
        return axios.put(requestsUri, serverRequest)
          .then(resp => {
            if (response.status == 200 && response.data.body)
              return true
            else
              throw new Error("Cannot update request");
          })
          .catch(err => {
            return false
          })
      }
    })
}

export const upsertRequest = (request) =>{
  return new Promise((resolve, reject) => {
    getUserToken()
    .then(tokenResponse => {
      var user = getCurrentFirebaseUser()
      if(!user) reject("not logged in")
      else {
        var serverRequest = {
          "propertyId": request.propertyId,
          "periodStart": request.periodStart,
          "periodEnd": request.periodEnd,
          "nrOfGuests": request.nrOfGuests,
          "txnDet": request.txnDet,
          "currency":request.txnDet.currency,
          "customOffer": request.customOffer,
          "token":tokenResponse,
          "agreedDeal": request.agreedDeal
        }
        if(request.id){
          //### UPDATE
          serverRequest.id= request.id
          serverRequest.status = request.status
        }else{
          // ### INSERT
          serverRequest.status = "active"
          serverRequest.listingMaaklerId = request.listingMaaklerId
          serverRequest.prospectUid= request.prospectUid,
          serverRequest.ownerUid= request.ownerUid
        }
        return axios.put(requestsUri, serverRequest)
      }
    })
    .then(resp => {
      resolve(true)
    })
    .catch(err => {
      reject(err)
    })
  })

}



// WEBPACK FOOTER //
// ./src/requestRepository.js